import React, { useEffect, useState, useCallback } from 'react'
import BarGraph from './BarGraph'
import dayjs from 'dayjs'
import { Tag } from 'antd'

const ITEMS_TO_SHOW = 5
const COMPONENT = 'component'
const SUBSYSTEM = 'subsystem'

const MostViewedSubsystem = ({
  allData,
  showDetailsOn,
  isFullScreen = false,
}) => {
  const [groupData, updatedGroupedData] = useState([])
  const [xField, setXField] = useState('Subsystem')
  const [yField, setYField] = useState('Count')

  useEffect(() => {
    let key = 'FUNCTIONAL_DIAGRAM_SUBSYSTEM_UPDATED'
    if (showDetailsOn === COMPONENT) {
      key = 'FUNCTIONAL_DIAGRAM_COMPONENT_UPDATED'
    }
    const data = allData && key ? allData[key] || [] : []
    if (!data || data.length === 0) {
      updatedGroupedData([])
      return
    }

    let filtered = data

    const grouped = {}
    let itemKeyGetter = (record) => record.eventData.subsystem
    if (showDetailsOn === COMPONENT) {
      itemKeyGetter = (record) =>
        record.componentDescription || record.eventData.componentId
    }
    filtered.forEach((record) => {
      const subsystem = itemKeyGetter(record)
      if (!grouped[subsystem]) grouped[subsystem] = 0
      grouped[subsystem]++
    })
    const mapped = Object.keys(grouped).map((subsystem) => {
      if (showDetailsOn === SUBSYSTEM) {
        return {
          Subsystem: subsystem,
          Count: grouped[subsystem],
        }
      } else {
        return {
          Component: subsystem,
          Count: grouped[subsystem],
        }
      }
    })
    // sort by Count desc and take top ITEMS_TO_SHOW
    mapped.sort((a, b) => b.Count - a.Count)
    if (!isFullScreen) {
      const limited = mapped.slice(0, ITEMS_TO_SHOW)
      updatedGroupedData(limited)
    } else {
      updatedGroupedData(mapped)
    }
    if (showDetailsOn === COMPONENT) {
      setXField('Component')
    } else {
      setXField('Subsystem')
    }
  }, [allData, showDetailsOn])

  return (
    <>
      <BarGraph
        data={groupData}
        xField={xField}
        yField={yField}
        isColumn={false}
        xShowColumn={true}
        yShowColumn={true}
        integerAxisLabels={true}
      />
    </>
  )
}

export default MostViewedSubsystem
